import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import './FollowListModal.css';

const API = process.env.REACT_APP_API_URL;

const Avatar = ({ username, photoUrl }) => {
  const initial = (username || '?')[0].toUpperCase();
  return photoUrl
    ? <img src={photoUrl} alt={username} className="flm-avatar-img" />
    : <div className="flm-avatar-placeholder">{initial}</div>;
};

const FollowListModal = ({ username, type, onClose, onViewProfile }) => {
  // type: 'followers' | 'following'
  const { t } = useTranslation();
  const [users, setUsers]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [followMap, setFollowMap] = useState({});
  const overlayRef = useRef(null);

  const token = () => localStorage.getItem('access_token');

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const url = type === 'followers'
          ? `${API}/users/${username}/followers/`
          : `${API}/users/${username}/following/`;
        const r = await axios.get(url, {
          headers: { Authorization: `Bearer ${token()}` },
        });
        setUsers(r.data);
      } catch {}
      finally { setLoading(false); }
    };
    fetchUsers();
  }, [username, type]);

  const handleFollow = async (targetUsername) => {
    try {
      const r = await axios.post(
        `${API}/follow/${targetUsername}/`,
        {},
        { headers: { Authorization: `Bearer ${token()}` } }
      );
      setFollowMap(prev => ({ ...prev, [targetUsername]: r.data.status }));
    } catch {}
  };

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) onClose();
  };

  const title = type === 'followers' ? t('followers') : t('following');

  return (
    <div className="flm-overlay" ref={overlayRef} onClick={handleOverlayClick}>
      <div className="flm-modal">
        <div className="flm-header">
          <span className="flm-title">{title}</span>
          <button className="flm-close" onClick={onClose}>✕</button>
        </div>

        {loading && <div className="flm-loading">{t('loading_dots')}</div>}

        {!loading && users.length === 0 && (
          <div className="flm-empty">
            {type === 'followers' ? t('no_followers_yet') : t('not_following_anyone')}
          </div>
        )}

        <div className="flm-list">
          {users.map(user => {
            const followStatus = followMap[user.username] ?? user.follow_status;
            const canNav = onViewProfile && !user.is_self;
            return (
              <div key={user.username} className="flm-row">
                <div
                  style={{ cursor: canNav ? 'pointer' : 'default', flexShrink: 0 }}
                  onClick={() => { if (canNav) { onClose(); onViewProfile(user.username); } }}
                >
                  <Avatar username={user.username} photoUrl={user.photo_url} />
                </div>
                <div
                  className="flm-row-info"
                  style={{ cursor: canNav ? 'pointer' : 'default' }}
                  onClick={() => { if (canNav) { onClose(); onViewProfile(user.username); } }}
                >
                  <span className="flm-row-username">@{user.username}</span>
                  {user.full_name && <span className="flm-row-fullname">{user.full_name}</span>}
                </div>
                {!user.is_self && (
                  <button
                    className={`flm-follow-btn ${
                      followStatus === 'following' ? 'flm-follow-btn--following' :
                      followStatus === 'pending'   ? 'flm-follow-btn--pending' : ''
                    }`}
                    onClick={() => handleFollow(user.username)}
                    disabled={followStatus === 'following' || followStatus === 'pending'}
                  >
                    {followStatus === 'following' ? t('follow_status_following') :
                     followStatus === 'pending'   ? t('follow_status_pending') : t('follow_action')}
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FollowListModal;
